import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=c377b88c&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=c377b88c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c377b88c",
  null
  
)

export default component.exports